export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Body_AO.fc16ecd3.tga";